import Rule from "../../../common/rule";

export default class ResetField extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedHistoryIndex === play.fragments?.length &&
            ruleContext.resetField
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { spots } = eventConfiguration;
        const { overtimeStartingYardline, driveStartingYardline } = spots;

        const startingYardline = gameContext.getOvertimePeriod()
            ? overtimeStartingYardline
            : driveStartingYardline;

        if (gameContext.isHomePossession()) {
            gameContext.setFieldPosition(startingYardline);
        } else {
            gameContext.setFieldPosition(
                gameContext.getFieldLength() - startingYardline
            );
        }

        ruleContext.setAwardFirstDown(true);
    }
}
